import script from "./idtags.vue?vue&type=script&setup=true&lang=js"
export * from "./idtags.vue?vue&type=script&setup=true&lang=js"

import "./idtags.vue?vue&type=style&index=0&id=b4f22228&lang=css"

const __exports__ = script;

export default __exports__